import StandaloneChatApp from '../ui/surfaces/standalone/index.jsx';
import InlineChatApp from '../ui/surfaces/inline/index.jsx';
import { createSurfaceRegistry } from './registry.ts';

export const defaultSurfaceRegistry = createSurfaceRegistry({
  standalone: StandaloneChatApp,
  inline: InlineChatApp,
});
